import { ArticleOrderDraft, ItemOrderDraft } from '../../domain/Order';

export default (articlesOrdersDrafts: ArticleOrderDraft[]): boolean => {
    let twoOrders: boolean = false;
    articlesOrdersDrafts.forEach((articleOrderDraft: ArticleOrderDraft) => {
        articleOrderDraft.itemsOrdersDrafts.forEach((itemOrderDraft: ItemOrderDraft) => {
            if (itemOrderDraft.toOrderFromStock > 0 && itemOrderDraft.toOrderFromEstimation > 0) {
                twoOrders = true;
            }
        });
    });
    return twoOrders;
};



// WEBPACK FOOTER //
// ./src/view/popup/checkIfTwoOrders.ts